const LabworkType = {
  Internal: 1,
  ByClient: 2,
  ClientDraw: 3
}

export default LabworkType;